import { getSettingsAction } from '~/api/functions/settings/get-settings.action'

interface Country {
  id: string
  title: {
    fa: string
    en?: string
  }
  flagUrl?: string
  iso: string
  callingCode: number
}

interface Currency {
  id: string
  titleFa: string
  titleEn: string
}

export function useSettings() {
  const {
    data: settings,
    pending: loadingSettings,
    error: settingsError,
    refresh: refreshSettings,
  } = useAsyncData('settings', () => getSettingsAction(), {
    transform: (res) => res?.data ?? {},
    default: () => ({
      countries: [],
      currencies: [],
    }),
  })

  const countries = computed(() => {
    return (settings.value?.countries ?? []).map((country: Country) => ({
      value: country.id,
      label: country.title.fa,
      flagUrl: country.flagUrl,
      iso: country.iso,
      callingCode: country.callingCode,
    }))
  })

  const currencies = computed(() => {
    return (settings.value?.currencies ?? []).map((currency: Currency) => ({
      value: currency.id,
      label: currency.titleFa,
      ...currency,
    }))
  })

  return {
    settings,

    countries,
    currencies,

    loadingSettings,
    settingsError,
    refreshSettings,
  }
}
